import {ChangeDetectorRef, Component, Input, TemplateRef, ViewChild, viewChild} from '@angular/core';

@Component({
  selector: 'app-warning-area',
  standalone: false,

  templateUrl: './warning-area.component.html',
  styleUrl: './warning-area.component.less'
})
export class WarningAreaComponent {

  @Input() titleTmpl: TemplateRef<any> | undefined;
  @Input() messageTmpl: TemplateRef<any> | undefined;
  @Input() actionTmpl: TemplateRef<any> | undefined;
  @Input() isError: boolean = false;
  @Input() applyZoomOut: boolean = true;

  _show: boolean = false;

  get show(): boolean {
    return this._show;
  }
  hide: boolean = false;

  @Input() set show(value: boolean) {
    if (this._show && !value) {
      // Si estaba visible y ahora se oculta, activar animación de salida
      if (this.applyZoomOut) {
        this.hide = true;

        setTimeout(() => {
          this._show = false;
          this.hide = false;
          this.cdr.detectChanges();
        }, 250); // Duración de la animación zoomOut
      } else {
        this._show = false;
        this.hide = false;
        this.cdr.detectChanges();
      }

    } else {
      // Si se muestra o no hay cambio, actualizar directamente
      this._show = value;
      this.hide = false;
      this.cdr.detectChanges();
    }
  }

  constructor(private cdr: ChangeDetectorRef) {
  }

}
